import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import SEO from '../components/SEO/SEO';
import './NotFoundPage.css';

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="not-found-page">
      <SEO
        page="notfound"
        noindex={true}
      />
      <Header />

      <div className="not-found-content">
        <div className="not-found-container">
          <h1 className="not-found-code">404</h1>
          <h2 className="not-found-title">{t('notFound.title', 'Page Not Found')}</h2>
          <p className="not-found-message">
            {t('notFound.message', "The page you're looking for doesn't exist or has been moved.")}
          </p>

          <div className="not-found-actions">
            <Link to="/trades" className="not-found-button primary">
              {t('notFound.goHome', 'Go to Trades')}
            </Link>
            <Link to="/bubbles" className="not-found-button secondary">
              {t('notFound.goBubbles', 'View Bubbles')}
            </Link>
          </div>

          <div className="not-found-links">
            <p>{t('notFound.tryLinks', 'Or try one of these:')}</p>
            <ul>
              <li><Link to="/trades">{t('nav.trades', 'Whale Trades')}</Link></li>
              <li><Link to="/hyperliquid">{t('nav.hyperliquid', 'Hyperliquid')}</Link></li>
              <li><Link to="/polymarket">{t('nav.polymarket', 'Polymarket')}</Link></li>
              <li><Link to="/rsi">{t('nav.rsi', 'RSI Heatmap')}</Link></li>
              <li><Link to="/bubbles">{t('nav.bubbles', 'Crypto Bubbles')}</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
